export default {
    leftname:"陽光智慧娛樂商戶平臺",
    loginname:"請輸入帳戶",
    loginyan:"請輸入驗證碼",
    loginpass:"請輸入帳戶密碼",
    loginqu:"我是渠道商",
    loginshang:"我是商戶",
    denglu:"登入",
    qudaoshang:"渠道商：",
    pingtai:"平臺",
    danjisaas:"單機運維系統",
    danjiding:"單機訂單系統",
    yangguang:"慧算通經營管理系統",
    mendian:"門店運維系統",
    mendianding:"門店訂單系統",
    quanxian:"員工管理" ,
    huanying:"歡迎登錄",
    tuichu:"登出"  ,
    shanghu:"商戶：",
    "下载": "下載",
    "收银客户端下载": "收銀用戶端下載",
    "谷歌浏览器下载": "穀歌瀏覽器下載",
    "阳光视翰官网": "陽光視翰官網",
    "24小时客服热线": "24小時客服熱線",
    "点击跳转": "點擊跳轉",
    "点击复制": "點擊複製",
    "记住密码": "記住密碼"
};